import { ArchitectureConfig } from './architecture-config';
import { globalArchitectureConfig } from './architecture-config';

/**
 * Filter architecture config to only include specified components and their connections
 */
export function filterArchitectureConfig(
  componentIds: string[]
): ArchitectureConfig {
  const filteredComponents: Record<string, any> = {};
  const filteredConnections: any[] = [];

  // Include only specified components
  componentIds.forEach((id) => {
    if (globalArchitectureConfig.components[id]) {
      filteredComponents[id] = globalArchitectureConfig.components[id];
    }
  });

  // Include only connections between included components
  globalArchitectureConfig.connections.forEach((conn) => {
    if (
      filteredComponents[conn.from] &&
      filteredComponents[conn.to]
    ) {
      filteredConnections.push(conn);
    }
  });

  return {
    components: filteredComponents,
    connections: filteredConnections,
  };
}


export const RealtimeProcessingConfig: ArchitectureConfig = filterArchitectureConfig([
  'frontend',
  'backend',
  'rabbitmq',
  'realtimeInferenceService',
  'postgres',
  'arc',
  'deepecho'
]);


/**
 * API as Service configuration - components used for API as Service feature
 * Includes: frontend, third party backend, backend, AI inference worker, redis and database
 */
export const apiAsServiceConfig: ArchitectureConfig = filterArchitectureConfig([
  'frontend',
  'thirdPartyBackend',
  'backend',
  'arqWorker',
  'batchInferenceService',
  'blindSweepInferenceService',
  'postgres',
  'rabbitmq',
  'gcp',
  'redis',
]);

export const ManualUploadConfig: ArchitectureConfig = filterArchitectureConfig([
  'frontend',
  'backend',
  'postgres',
  'arc',
  'gcp',
  'redis',
  'arqWorker',
  'rabbitmq',
  'batchInferenceService',
  'blindSweepInferenceService',
]);

export const PacsGatewayConfig: ArchitectureConfig = filterArchitectureConfig([
  'echography',
  'vscan',
  'butterfly',
  'deepecho',
  'frontend',
  'pacsScp',
  'backend',
  'arc',
  'postgres',
  'redis',
  'rabbitmq',
  'videoWorker',
  'gcp',
  'batchInferenceService',
  'blindSweepInferenceService',
]);

export const AIinferenceWorkerConfig: ArchitectureConfig = filterArchitectureConfig([
  'rabbitmq',
  'aiService',
  'gcp',
  'arc'
]);


export const PacsConnectionConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);



export const NotificationSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);


export const PACSSyncConfig: ArchitectureConfig = filterArchitectureConfig([
  'pacsScp',
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);


export const AuthenticationSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'frontend',
  'deepecho',
  'backend',
  'postgres',
  'redis',
  'gcp',
  'idp',
  'emailService',
]);

export const AuthorizationSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);

export const ExamManagementSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);


export const patientManagementSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);

export const UserManagementSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'frontend',
  'backend',
  'postgres',
  'gcp',
  'emailService',
  'deepecho',
  'redis'
]);



export const DataFromPacsSyncConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);

export const DeviceManagementSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);





export const PatientAccountConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);

export const OhifRemovalConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);

export const TwoFactorAuthenticationConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);


export const BillingSystemConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);

export const MyAccountConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);


export const pixelSpacingDetectionConfig: ArchitectureConfig = filterArchitectureConfig([
  'backend',
  'rabbitmq',
  'videoWorker',
  'aiService',
  'gcp',
]);